// extracted by mini-css-extract-plugin
export default {"closeeBtn":"styles_closeeBtn__nhL9H","loadMoreBtn":"styles_loadMoreBtn__Ikeji","infoBadge":"styles_infoBadge__PzHmu"};